/* ------------------------------------------------------------------
   Autoplay product-gallery videos only while they are on screen.

   The theme renders gallery videos inside <deferred-media> with a
   <template>, so the <video> stays out of the DOM until loadContent()
   runs. We call loadContent() lazily the first time a video slide
   scrolls into view, then play/pause it as it enters/leaves the
   viewport. This keeps videos off the critical path (preload:none),
   avoids decoding videos the shopper never sees, and saves battery by
   pausing off-screen playback.

   Respects prefers-reduced-motion: users who opt out keep the manual
   click-to-play poster behaviour.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  // Play when at least half the media is visible; pause once it leaves.
  var VISIBLE_RATIO = 0.5;

  function playVisible(container) {
    // loadContent() injects the <video> and, because the tag carries
    // autoplay+muted, starts playback. Guard so it only runs once.
    if (!container.hasAttribute('loaded')) {
      if (typeof container.loadContent === 'function') {
        // false = do not steal focus when auto-starting.
        container.loadContent(false);
      }
      return;
    }
    var video = container.querySelector('video');
    if (video && video.paused) {
      var p = video.play();
      // Autoplay can still be rejected; swallow the promise rejection
      // so it never surfaces as an unhandled error.
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function pause(container) {
    var video = container.querySelector('video');
    if (video && !video.paused) video.pause();
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var container = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= VISIBLE_RATIO) {
          playVisible(container);
        } else {
          pause(container);
        }
      });
    },
    { threshold: [0, VISIBLE_RATIO] }
  );

  function observeVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    // Only native video deferred-media inside the product gallery; skip
    // model-viewer and external (YouTube/Vimeo) which have their own UX.
    scope
      .querySelectorAll('.product__slide[data-video] deferred-media')
      .forEach(function (el) {
        if (el.dataset.diaAutoplayBound) return;
        // external_video slides carry a youtube id on the wrapper; leave those.
        var slide = el.closest('.product__slide');
        if (slide && slide.hasAttribute('data-youtube-id')) return;
        el.dataset.diaAutoplayBound = '1';
        observer.observe(el);
      });
  }

  function init() {
    observeVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Product info re-renders the gallery on variant change; re-scan then.
  document.addEventListener('theme:product-info:loaded', function (e) {
    observeVideos(e.target);
  });
})();
